import React from 'react';

import IconContentBlock from './IconContentBlock';
import SectionHero from './SectionHero';

const USPGrid = ({
  title = 'Why GraphCMS',
  description = 'Discover how a GraphQL Headless CMS accelerates your website projects',
  items,
  ...props
}) => {
  if (!items) return null;

  const Component = (item, index) => (
    <IconContentBlock key={index} {...item} {...props} />
  );

  return (
    <React.Fragment>
      {title && (
        <SectionHero title={title} description={description} {...props} />
      )}

      <div className="flex flex-wrap lg:-mx-6">{items.map(Component)}</div>
    </React.Fragment>
  );
};

export default USPGrid;
